<div class="banner">
    <img src="/assets/img/banner/2.jpg" alt="Banner">
</div>
<div class="container-fluid innerPageMenu">
    <div class="row">
        <div class="col-md-3">
            <nav id="secondary-navigation">
                <!-- Header -->
                <header class="header">
                    <h5>We MPPIANS</h5>
                </header>
                <!-- /Header -->
                <ul>
                    <li routerLinkActive="active">
                        <a routerLink="/about-us/vision" >  Mission & Vision</a>
                    </li>
                    <li routerLinkActive="active">
                        <a  routerLink="/about-us/principal" > Principal's Message</a>
                    </li>
                </ul>
            </nav>
            <!-- <div class="row">
                <div class="col-12 text-center">
                    <img src="/assets/img/message/1.jpg" alt="Principal" class="img-fluid rounded " style="max-height: 300px;">
                    <h5 class="text-center mt-4">Principal</h5>
                </div>
            </div> -->
        </div>
        <div class="col-md-9">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>